@if (open()) {
  <div class="lab-command-palette" (keydown)="onKeydown($event)">
    <button
      type="button"
      class="lab-command-palette__backdrop"
      aria-label="Close command palette"
      (click)="close()"
    ></button>
    <div #surface class="lab-command-palette__surface" role="dialog" aria-label="Command palette">
      <div class="lab-command-palette__input">
        <lab-search-field [value]="query()" [immediate]="true" (valueChange)="onQueryChange($event)" />
      </div>

      @if (filteredItems().length > 0) {
        <div class="lab-command-palette__results" role="listbox">
          @for (item of filteredItems(); track item.id; let i = $index) {
            <button
              class="lab-command-palette__result"
              [class.lab-command-palette__result--active]="activeIndex() === i"
              role="option"
              type="button"
              [attr.aria-selected]="activeIndex() === i"
              (click)="navigate(item.id)"
              (mouseenter)="setActive(i)"
            >
              @if (item.icon) {
                <lab-icon class="lab-command-palette__result-icon" [name]="item.icon" size="16" />
              }
              <span class="lab-command-palette__result-label">{{ item.label }}</span>
              @if (item.groupLabel) {
                <span class="lab-command-palette__result-group">{{ item.groupLabel }}</span>
              }
            </button>
          }
        </div>
      } @else {
        <div class="lab-command-palette__empty">No results</div>
      }

      <div class="lab-command-palette__hints">
        <span><kbd>↑</kbd><kbd>↓</kbd> navigate</span>
        <span><kbd>↵</kbd> open</span>
        <span><kbd>esc</kbd> close</span>
      </div>
    </div>
  </div>
}
